import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '../../lib/analytics'

interface AccordionItem {
  q: string
  a: string
}

function AccordionEntry({
  item,
  accentColor,
}: {
  item: AccordionItem
  accentColor: string
}) {
  const [open, setOpen] = useState(false)

  return (
    <div className="clay-card rounded-twelve transition-all">
      <button
        className="w-full list-none p-6 flex items-center justify-between cursor-pointer font-black text-lg text-left"
        onClick={() => {
          const next = !open
          setOpen(next)
          if (next) trackEvent('faq_open', { question: item.q.slice(0, 100) })
        }}
        aria-expanded={open}
      >
        <span>{item.q}</span>
        <span
          className={`${accentColor} text-2xl transition-transform duration-200 flex-shrink-0 ml-4`}
          style={{ transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          +
        </span>
      </button>
      {open && (
        <div
          className="px-6 pb-6 text-slate-700 dark:text-slate-200 font-bold leading-relaxed"
          dangerouslySetInnerHTML={{ __html: item.a }}
        />
      )}
    </div>
  )
}

export default function FAQSection() {
  const { t } = useTranslation()

  const faqItems = t('faq.items', { returnObjects: true }) as AccordionItem[]
  const accentColors = ['text-neonBlue', 'text-neonPink', 'text-neonGreen']

  return (
    <section className="max-w-4xl mx-auto mb-20">
      <h4 className="text-2xl font-black text-center text-slate-600 dark:text-slate-200 mb-8 tracking-[0.2em] uppercase">
        {t('faq.comprehensiveTitle')}
      </h4>
      <div className="space-y-4">
        {faqItems.map((item, i) => (
          <AccordionEntry
            key={i}
            item={item}
            accentColor={accentColors[i % accentColors.length]}
          />
        ))}
      </div>
    </section>
  )
}
